import { t } from "@travily/i18n";
import type { MessagesConversationLastMessageTrait } from "@travily/types/models/MessagesConversation";
import type Participation from "@travily/types/models/MessagesParticipation";
import { Icon } from "@ui/components/Icon";
import { ConversationListItem } from "./components/ConversationListItem";
import { ConversationListSkeleton } from "./components/ConversationListSkeleton";

export type ConversationParticipation = Participation & {
  conversation: Participation["conversation"] & MessagesConversationLastMessageTrait;
};

export interface ConversationListViewProps {
  activeConversationSqid?: string;
  /** Whether a filter is narrowing the list — changes what an empty list means, and so what it says. */
  isFiltering?: boolean;
  participations: ConversationParticipation[] | undefined;
}

export function ConversationListView({
  activeConversationSqid,
  isFiltering = false,
  participations,
}: ConversationListViewProps) {
  if (participations === undefined) {
    return <ConversationListSkeleton />;
  }

  if (participations.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 px-4 py-12 text-center">
        <Icon className="text-neutral-300" name="message" size="32" />
        <p className="text-neutral-500 text-sm">
          {isFiltering
            ? t("components.views.messages.conversation_list_view.empty_filtered")
            : t("components.views.messages.conversation_list_view.empty")}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {participations.map((participation) => (
        <ConversationListItem
          key={participation.conversation.sqid}
          conversation={participation}
          isActive={participation.conversation.sqid === activeConversationSqid}
        />
      ))}
    </div>
  );
}
